export const changeImageSize = (image, size) => {
  if (image) {
    return image.replace('original', size)
  }
  return ''
}

export const validateEmail = (email) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
}

export const validateUrl = (url) => {
  return /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/.test(url)
}

export const validateTitle = (title) => {
  return !/[^\wа-яёА-ЯЁ\u0561-\u0587\u0531-\u0556-+_&'" ,]+/.test(title)
}

export const validateJson = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export const createLocation = (addressData) => {
  let address = addressData.address
  let label = ''
  if (addressData.matchLevel === 'country' || addressData.matchLevel === 'county') {
    label = addressData.label
  } else {
    if (address.country) {
      label += address.country
    }
    if (address.city) {
      label += ', ' + address.city
    }
    if (address.district && address.district !== address.city) {
      label += ', ' + address.district
    }
    if (address.street && address.street !== address.district) {
      label += ', ' + address.street
    }
  }
  return label
}

export const getOS = () => {
  let userAgent = window.navigator.userAgent
  let platform = window.navigator.platform
  let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
  let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
  let iosPlatforms = ['iPhone', 'iPad', 'iPod']
  let os = null

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS'
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS'
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows'
  } else if (/Android/.test(userAgent)) {
    os = 'Android'
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux'
  }

  return os
}

export const isLinux = () => {
  return getOS() === 'Linux'
}

export const last = (array, n) => {
  if (array == null) {
    return void 0
  }
  if (n == null) {
    return array[array.length - 1]
  }
  return array.slice(Math.max(array.length - n, 0))
}



// WEBPACK FOOTER //
// ./src/helpers/main.js